import initialState from './initialstate';
import * as types from '../Actions/actiontypes';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function TaskDetailReducer(state = initialState.taskDetail, action) {
	switch (action.type) {
		case types.HO_GET_TASK_DETAILS: {
			let taskDetails = action.response;
			if (action.payload) {
				taskDetails.payload = action.payload;
			}
			let taskDetailsCopy = _.cloneDeep(taskDetails);
			let isEPSignoffUserRequiredInitialState = taskDetailsCopy.isEPSignoffUserRequired;
			let isEQRSignoffUserRequiredInitialState = taskDetailsCopy.isEQRSignoffUserRequired;

			return {
				taskStatusId: 0,
				...taskDetails,
				isEPSignoffUserRequiredInitialState: isEPSignoffUserRequiredInitialState,
				isEQRSignoffUserRequiredInitialState: isEQRSignoffUserRequiredInitialState,
				isTaskGetByIdCallComplated: state && state.resetTask ? false : true,
				description: taskDetails.description
			};
		}

		default:
			return state;
	}
}
